import React, { Component } from 'react'
import { connect } from 'react-redux'

export function mapStateToProps(state) {
    return {
        license: {
            name: state.getIn(['authorization', 'license', 'licenceName'], 0),
        },
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
